import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { FormField } from '../../../interfaces/form.interface';
import { InputType } from '../../../interfaces/input.interface';

@Component({
    selector: 'app-reactive-read-only-field',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './read-only-field.component.html',
    styleUrls: ['./read-only-field.component.scss'],
})
export class ReactiveReadOnlyFieldComponent<T> {
    @Input() field!: FormField<T>;

    @Input() model!: FormGroup;

    public readonly inputType = InputType;

    public getReadOnlyDisplayValue(): string {
        const value = this.model.get(this.field.name ?? '')?.value;

        if (value == null || value === '') {
            return '-';
        }

        if (Array.isArray(value)) {
            const parts = value
                .map((item) => this.stringifyItem(item))
                .filter((item) => item !== '');

            return parts.length > 0 ? parts.join(', ') : '-';
        }

        return this.stringifyItem(value) || '-';
    }

    private stringifyItem(value: unknown): string {
        if (value == null) {
            return '';
        }

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }

        if (typeof value === 'object') {
            const record = value as Record<string, unknown>;

            return String(
                record['label']
                ?? record['nombre']
                ?? record['name']
                ?? record['descripcion']
                ?? record['uso']
                ?? record['agente']
                ?? ''
            ).trim();
        }

        return '';
    }
}
